<div
  class="mx-auto h-full w-full max-w-4xl overflow-y-auto rounded bg-white p-4 shadow-sm dark:bg-gray-800">
  <form [formGroup]="solverForm" (ngSubmit)="onSubmit()" class="space-y-8">
    <!-- Objective Function Section -->
    <div class="space-y-6">
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
        Configuration de l'objectif
      </h2>

      <!-- <!-1- Weight Total Indicator -1-> -->
      <!-- <div class="flex items-center justify-between p-3 rounded-lg" -->
      <!--   [class]="isWeightValid ? 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700' : 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700'"> -->
      <!--   <span class="text-sm font-medium" -->
      <!--     [class]="isWeightValid ? 'text-green-800 dark:text-green-200' : 'text-red-800 dark:text-red-200'"> -->
      <!--     Total Weight: {{ totalWeight() }}% -->
      <!--   </span> -->
      <!--   <span class="text-xs" -->
      <!--     [class]="isWeightValid ? 'text-green-600 dark:text-green-300' : 'text-red-600 dark:text-red-300'"> -->
      <!--     {{ isWeightValid ? 'Valid' : 'Must equal 100%' }} -->
      <!--   </span> -->
      <!-- </div> -->

      <!-- Triangle Interface -->
      <div class="flex flex-col items-center gap-8 p-5 lg:flex-row">
        <!-- Triangle Visualization -->
        <div class="flex flex-1 justify-center">
          <div class="relative">
            <svg
              #triangleSvg
              width="500"
              height="400"
              viewBox="0 0 500 400"
              class="cursor-pointer select-none"
              (mousedown)="onMouseDown($event)">
              <!-- Triangle -->
              <polygon
                [attr.points]="
                  vertices.operational.x +
                  ',' +
                  vertices.operational.y +
                  ' ' +
                  vertices.distance.x +
                  ',' +
                  vertices.distance.y +
                  ' ' +
                  vertices.time.x +
                  ',' +
                  vertices.time.y
                "
                fill="none"
                stroke="#10b981"
                stroke-width="3"
                class="dark:stroke-accent-focus" />

              <!-- Triangle fill with gradient -->
              <defs>
                <linearGradient id="triangleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color: #10b981; stop-opacity: 0.1" />
                  <stop offset="100%" style="stop-color: #059669; stop-opacity: 0.2" />
                </linearGradient>
              </defs>

              <polygon
                [attr.points]="
                  vertices.operational.x +
                  ',' +
                  vertices.operational.y +
                  ' ' +
                  vertices.distance.x +
                  ',' +
                  vertices.distance.y +
                  ' ' +
                  vertices.time.x +
                  ',' +
                  vertices.time.y
                "
                fill="url(#triangleGradient)" />

              <!-- Vertex circles -->
              <circle
                [attr.cx]="vertices.operational.x"
                [attr.cy]="vertices.operational.y"
                r="8"
                fill="#10b981"
                class="dark:fill-accent-focus" />
              <circle
                [attr.cx]="vertices.distance.x"
                [attr.cy]="vertices.distance.y"
                r="8"
                fill="#10b981"
                class="dark:fill-accent-focus" />
              <circle
                [attr.cx]="vertices.time.x"
                [attr.cy]="vertices.time.y"
                r="8"
                fill="#10b981"
                class="dark:fill-accent-focus" />

              <!-- Vertex labels -->
              <text
                [attr.x]="vertices.operational.x"
                [attr.y]="vertices.operational.y - 15"
                text-anchor="middle"
                class="fill-gray-800 text-sm font-semibold dark:fill-gray-200">
                Coût
              </text>
              <text
                [attr.x]="vertices.distance.x - 20"
                [attr.y]="vertices.distance.y + 25"
                text-anchor="middle"
                class="w-5 translate-x-6 fill-gray-800 text-sm font-semibold dark:fill-gray-200">
                Distance
              </text>
              <text
                [attr.x]="vertices.time.x + 20"
                [attr.y]="vertices.time.y + 25"
                text-anchor="middle"
                class="-translate-x-6 fill-gray-800 text-sm font-semibold dark:fill-gray-200">
                Temps
              </text>

              <!-- Draggable point -->
              <circle
                [attr.cx]="currentPoint().x"
                [attr.cy]="currentPoint().y"
                r="10"
                fill="#ef4444"
                stroke="#ffffff"
                stroke-width="2"
                class="cursor-move shadow-lg" />

              <!-- Point center dot -->
              <circle
                [attr.cx]="currentPoint().x"
                [attr.cy]="currentPoint().y"
                r="3"
                fill="#ffffff" />
            </svg>

            <!-- Instructions -->
            <div
              class="absolute -bottom-6 left-1/2 -translate-x-1/2 transform text-center text-xs text-gray-500 dark:text-gray-400">
              Déplacer le point pour ajuster les poids de l'objectif
            </div>
          </div>
        </div>

        <!-- Weight Display -->
        <div class="space-y-4 lg:w-80">
          <div class="space-y-3 rounded-lg bg-gray-50 p-4 dark:bg-gray-700">
            <h4 class="font-medium text-gray-800 dark:text-gray-200">
              Pondération choisie
            </h4>

            <div class="space-y-2">
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-blue-600 dark:text-blue-400"
                  >Coût:</span
                >
                <span class="font-semibold text-blue-700 dark:text-blue-300"
                  >{{ solverForm.get('operationalCostWeight')?.value }}%</span
                >
              </div>
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-purple-600 dark:text-purple-400"
                  >Distance:</span
                >
                <span class="font-semibold text-purple-700 dark:text-purple-300"
                  >{{ solverForm.get('distanceTravelWeight')?.value }}%</span
                >
              </div>
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-orange-600 dark:text-orange-400"
                  >Temps:</span
                >
                <span class="font-semibold text-orange-700 dark:text-orange-300"
                  >{{ solverForm.get('timeSpentWeight')?.value }}%</span
                >
              </div>
            </div>

            <!-- Visual bars -->
            <div class="space-y-2 pt-2">
              <div class="flex items-center gap-2">
                <div class="h-3 w-3 rounded-full bg-blue-500"></div>
                <div class="h-2 flex-1 rounded-full bg-gray-200 dark:bg-gray-600">
                  <div
                    class="duration-slow h-2 rounded-full bg-blue-500 transition-all"
                    [style.width.%]="solverForm.get('operationalCostWeight')?.value"></div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <div class="h-3 w-3 rounded-full bg-purple-500"></div>
                <div class="h-2 flex-1 rounded-full bg-gray-200 dark:bg-gray-600">
                  <div
                    class="duration-slow h-2 rounded-full bg-purple-500 transition-all"
                    [style.width.%]="solverForm.get('distanceTravelWeight')?.value"></div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <div class="h-3 w-3 rounded-full bg-orange-500"></div>
                <div class="h-2 flex-1 rounded-full bg-gray-200 dark:bg-gray-600">
                  <div
                    class="duration-slow h-2 rounded-full bg-orange-500 transition-all"
                    [style.width.%]="solverForm.get('timeSpentWeight')?.value"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-between pt-6">
      <button
        type="button"
        (click)="resetWeights()"
        class="rounded-md border border-gray-300 bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:ring-2 focus:ring-gray-500 focus:outline-none dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600">
        Rétablir
      </button>

      <button
        type="submit"
        class="rounded-md border border-gray-300 bg-teal-800 px-4 py-2 text-sm font-medium text-zinc-100 hover:bg-teal-700 focus:ring-2 focus:ring-gray-500 focus:outline-none dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600">
        Valider
      </button>
    </div>
  </form>
</div>
